import React from 'react';
import { EmptyState } from '@atlassian/search-dialog';

import { type WrappedComponentProps, injectIntl } from 'react-intl-next';
import { messages } from '../../messages';

const Image = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/prequery-error-image" */ './error-image'
		),
);

const PreQueryErrorScreen: React.FunctionComponent<WrappedComponentProps> = ({ intl }) => (
	<EmptyState
		title={intl.formatMessage(messages.common_error_state_prequery_heading)}
		Image={Image}
	/>
);

export default injectIntl(PreQueryErrorScreen);
